// src/pages/MyIncomeCreditsAbout.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import adimage1 from "../../assets/pageimages/roomanywhere/raindeximg1.png";
import adimage2 from "../../assets/navlogo.png";

const MyIncomeCreditsAbout = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 [&_p]:text-gray-100 font-sans">

      {/* HEADER */}
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">
            My Income Credits
          </div>
          <div className="text-[11px] text-gray-200">
            Think5Whys Micro Digital Income Initiative for the World!
          </div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700"
              >
                ⏻
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
            >
              🔐
            </button>
          )}
        </div>

        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 rounded-md bg-red-600 hover:bg-red-700"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex justify-center">
              <Link to="/login" className="text-teal-300">
                🔐
              </Link>
            </div>
          )}
        </div>
      )}

      {/* TOP AD */}
      <div
        className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 flex items-center gap-3"
        onClick={() => navigate("/roomanywhere")}
      >
        <div className="w-20 h-20 rounded overflow-hidden bg-gray-700">
          <img src={adimage1} alt="Ad" className="w-full h-full object-cover" />
        </div>

        <div>
          <p className="text-xs uppercase text-gray-400">Think5Whys Ad</p>
          <p className="font-semibold text-lg">
            <span className="text-yellow-200">RoomAnywhere</span>: Make Indoor
            and Outdoor Room
          </p>
          <p className="text-sm">Click to see more!</p>
        </div>
      </div>

      {/* ABOUT CONTENT */}
      <main className="flex-grow mx-auto px-4 py-6">

        <h1 className="text-2xl font-bold text-yellow-200 mb-4">
          About My Income Credits
        </h1>

        <p className="mb-4 text-gray-300">
          <strong>My Income Credits</strong> is a micro digital income
          ecosystem created by Think5Whys. It enables individuals around the
          world to participate in knowledge sharing, digital collaboration,
          entrepreneurship, and community building while earning income
          credits.
        </p>

        <h2 className="text-xl text-teal-300 mt-6 mb-2">
          How You Can Earn
        </h2>

        <ul className="list-disc ml-6 space-y-2 [&_li]:text-gray-300">
          <li>Referral network participation</li>
          <li>Reselling knowledge products</li>
          <li>Content creation and media contributions</li>
          <li>Authoring books and digital knowledge modules</li>
          <li>Counselling and consulting services</li>
          <li>Boutique advisory expertise</li>
          <li>Franchise ecosystem participation</li>
          <li>Readfluencing and book promotion</li>
          <li>Internship learning programs</li>
          <li>Watching platform ads and videos</li>
          <li>Donations and community contributions</li>
          <li>Institutional or group income</li>
        </ul>

        <h2 className="text-xl text-teal-300 mt-6 mb-2">
          Referral Network Model
        </h2>

        <p className="text-gray-300">
          The platform also supports a multi-level referral network structure
          where users can build a knowledge community up to multiple levels.
          Contributions and activities within the network may generate
          additional income credits.
        </p>

        <h2 className="text-xl text-teal-300 mt-6 mb-2">
          Our Vision
        </h2>

        <p className="text-gray-300">
          Think5Whys believes that the future of work will be decentralized,
          knowledge-driven, and digitally enabled. My Income Credits aims to
          empower individuals globally by providing micro opportunities for
          learning, collaboration, and earning through digital platforms.
        </p>

      </main>

      {/* BOTTOM AD */}
      <div
        className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 flex items-center gap-3"
        onClick={() => window.open("https://www.think5whys.com", "_blank")}
      >
        <div className="w-16 h-16 bg-gray-700 rounded overflow-hidden">
          <img src={adimage2} alt="Ad" className="w-full h-full object-cover" />
        </div>

        <div>
          <p className="text-xs uppercase text-gray-400">Google Ad</p>
          <p className="font-semibold text-lg">
            Think5Whys: Your Platform for Transformation
          </p>
          <p className="text-sm">Click to see more!</p>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">
            © 2026 Think5Whys Global DeepTech Solutions.
          </div>

          <div className="flex gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">
              About
            </Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">
              Privacy Policy
            </Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">
              Terms of Use
            </Link>
            <Link to="/contact-us" className="hover:text-teal-300">
              Contact
            </Link>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default MyIncomeCreditsAbout;